
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seed",
      function () {
        return require("private-next-pages/seed/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seed"])
      });
    }
  